module.exports = __webpack_public_path__ + "img/mary-church-terrell.69d4342f.png";